import * as actionTypes from "../../actionTypes";
import * as api from "../../../api/index";
import { toast } from "react-toastify";

export const GetWorkflowTemplatesCERT = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  try {
    const { data, status } = await api.getWorkflowTemplatesCERT(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_WORKFLOW_TEMPLATES_CERT, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
};

export const CreateWorkflowTemplateCERT = (form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.createWorkflowTemplateCERT(form);
    statusCode = status;
    if (status === 201) {
      toast.success(data.message || 'Template created');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    const serverMessage = error?.response?.data?.message
      || (Array.isArray(error?.response?.data?.error) ? error.response.data.error[0] : null);
    if (serverMessage) toast.error(serverMessage);
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    statusCode = error?.response?.status;
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

export const UpdateWorkflowTemplateCERT = (id, form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.updateWorkflowTemplateCERT(id, form);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Template updated');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

export const SyncWorkflowTemplatesCERT = (form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.syncWorkflowTemplatesCERT(form);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Templates synced');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

// Pulls the live template list from be-ai-agent-1 and inserts only the ones
// we don't already have (matched by external_template_id) — existing rows,
// their flags, and their allotments are left untouched.
export const SyncWorkflowTemplatesFromSourceCERT = (setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode, data;
  try {
    ({ data, status: statusCode } = await api.syncWorkflowTemplatesFromSourceCERT());
    if (statusCode === 200) {
      const { created_count, skipped_count } = data?.data || {};
      toast.success(data.message || `Synced: ${created_count} added, ${skipped_count} already present`);
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    const serverMessage = error?.response?.data?.message;
    if (serverMessage) toast.error(serverMessage);
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    statusCode = error?.response?.status;
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode, data: data?.data };
};

export const GetWorkflowTemplateAuthoritiesCERT = (id, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  try {
    const { data, status } = await api.getWorkflowTemplateAuthoritiesCERT(id);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_WORKFLOW_TEMPLATE_AUTHORITIES_CERT, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
};

export const AllotWorkflowTemplateToAuthoritiesCERT = (id, form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.allotWorkflowTemplateToAuthoritiesCERT(id, form);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Template allotted');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

export const UpdateWorkflowTemplateAuthorityAllotmentCERT = (id, authorityUserId, form, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.updateWorkflowTemplateAuthorityAllotmentCERT(id, authorityUserId, form);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Allotment updated');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};

export const RemoveWorkflowTemplateAuthorityAllotmentCERT = (id, authorityUserId, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  let statusCode;
  try {
    const { data, status } = await api.removeWorkflowTemplateAuthorityAllotmentCERT(id, authorityUserId);
    statusCode = status;
    if (status === 200) {
      toast.success(data.message || 'Allotment removed');
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
  } finally {
    if (setLoading) setLoading(false);
  }
  return { statusCode };
};
